import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'img-tag',
  props: {
    src: null,
    lazySrc: {
      default: ''
    },
    alt: {
      default: ''
    },
    width: {
      default: ''
    },
    height: {
      default: ''
    },
    contain: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      default: undefined
    },
    maxWidth: {
      default: undefined
    },
    minWidth: {
      default: undefined
    },
    maxHeight: {
      default: undefined
    },
    minheight: {
      default: undefined
    }
  },
  emits: ['mouse-enter', 'mouse-leave', 'click'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const imageBinding = computed(() => {
      return {
        src: props.src,
        lazySrc: props.lazySrc,
        alt: props.alt,
        width: props.width,
        height: props.height,
        contain: props.contain,
        class: props.rounded ? 'roundedCorner' : '',
        aspectRatio: props.aspectRatio,
        'max-width': props.maxWidth,
        'min-width': props.minWidth,
        'max-height': props.maxHeight,
        'min-height': props.minheight
      };
    });
    return {
      __sfc: true,
      props,
      emit,
      imageBinding
    };
  }
});